/** Only application-relative destinations; reject protocol-relative URLs,
 * backslashes, control characters and encoded versions of those inputs.
 */
export function normalizeReturnToPath(value: string | null | undefined): string | undefined {
  if (!value || !value.startsWith('/') || value === '/') return undefined;
  let decoded: string;
  try { decoded = decodeURIComponent(value); } catch { return undefined; }
  if (decoded.startsWith('//') || decoded.includes('\\') ||
      Array.from(decoded).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return undefined;
  const path = new URL(value, 'https://event.invalid');
  if (path.origin !== 'https://event.invalid' ||
      ['/signin', '/auth/callback'].some((prefix) => path.pathname.startsWith(prefix))) return undefined;
  return value;
}
